import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  FormGroup,
  FormControlLabel,
  Checkbox,
  TextField,
  Typography,
  Grid,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import style from "../../styles/common/filter.module.css";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import ApplyButton from "../../Pages/Masters/Roles and Permissions/Filters/ApplyButton";
import ResetButton from "../../Pages/Masters/Roles and Permissions/Filters/ResetButton";
import "../../Pages/Masters/Roles and Permissions/Filters//Scrollbar.css";
import { format } from "date-fns";
import { validateNumberInput } from "../../utils/validateFields";

dayjs.extend(utc);
const today = dayjs();

const FilterModal = ({
  isOpen,
  onClose,
  filters,
  onFilterChange,
  title,
  placeholderMax,
  placeholderMin,
}) => {
  const [filterObj, setFilterObj] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({});
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [time, setTime] = useState();
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (filters.length > 0) {
      setSelectedFilter(filters[0]);
    }
  }, [filters]);

  const handleOptionChange = (key, option, checked) => {
    setFilterObj((prev) => {
      const selectedOptions = prev[key] || [];
      let updatedOptions;

      if (checked) {
        updatedOptions = [...selectedOptions, option];
      } else {
        updatedOptions = selectedOptions.filter((item) => item !== option);
      }

      // Ensure we return an object even if no options are selected
      const newFilterObj = {
        ...prev,
        [key]: updatedOptions.length > 0 ? updatedOptions : undefined,
      };

      return newFilterObj;
    });
  };

  const handleDateChange = (key, dateType, value) => {
    const formattedDate = value ? dayjs(value).format("YYYY-MM-DD") : "";
    setFilterObj((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [dateType]: formattedDate,
      },
    }));
  };

  const handleMonthChange = (key, monthType, value) => {
    const formattedMonth = value ? dayjs(value).format("YYYY-MM") : "";
    setFilterObj((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [monthType]: formattedMonth,
      },
    }));
  };

  useEffect(() => {
    setErrors({});
  }, []);

  const handleTimeChange = (key, value) => {
    if (!value) return;
    setTime(value);
    setFilterObj((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [key]: value, // Save the formatted time
      },
    }));
  };

  const handleLimitChange = (key, type, value) => {
    if (!validateNumberInput(value)) return;
    setFilterObj((prev) => {
      const updated = {
        ...prev,
        [key]: {
          ...prev[key],
          [type]: value,
        },
      };

      const min = updated[key]?.min;
      const max = updated[key]?.max;

      const parsedMin =
        min !== undefined && min !== "" ? parseFloat(min) : null;
      const parsedMax =
        max !== undefined && max !== "" ? parseFloat(max) : null;

      // Validate only if both min and max are entered and are valid numbers
      if (!isNaN(parsedMin) && !isNaN(parsedMax)) {
        if (type === "min" && parsedMax < parsedMin) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [key]: "Min value cannot be greater than Max value.",
          }));
        } else if (type === "max" && parsedMax < parsedMin) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [key]: "Max value cannot be less than Min value.",
          }));
        } else {
          setErrors((prevErrors) => ({ ...prevErrors, [key]: "" }));
        }
      }
      return updated;
    });
  };

  useEffect(() => {
    if (!isOpen) {
      setErrors({});
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      // Initialize each filter type with proper empty state
      const initialState = filters.reduce((acc, filter) => {
        if (filter.type === "option") {
          acc[filter.key] = [];
        } else if (filter.type === "date" || filter.type === "month") {
          acc[filter.key] = { start: undefined, end: undefined };
        } else if (filter.type === "limit") {
          acc[filter.key] = { min: undefined, max: undefined };
        }
        return acc;
      }, {});

      setFilterObj({ ...initialState, ...appliedFilters });
      setErrors({});
    }
  }, [isOpen, filters, appliedFilters]);

  // const handleFilterChange = (filter) => {
  //   errors?.[selectedFilter?.key] === filter?.key
  //     ? setFilterObj((prev) => ({
  //         ...prev,
  //         [filter?.key]: "",
  //       }))
  //     : setErrors({ ...errors, [filter?.key]: "" });
  //   setSelectedFilter(filter);
  // };
  //   const applyFilters = () => {
  //   const hasErrorInOtherFilters = Object.entries(errors).some(([key, value]) => {
  //     if (key === selectedFilter?.key) return false;

  //     return (
  //       (typeof value === "string" && value.trim() !== "") ||
  //       (typeof value === "object" && Object.keys(value).length > 0)
  //     );
  //   });

  //   const selectedFilterHasNoError =
  //     !errors[selectedFilter?.key] ||
  //     (typeof errors[selectedFilter?.key] === "string" && errors[selectedFilter?.key].trim() === "") ||
  //     (typeof errors[selectedFilter?.key] === "object" && Object.keys(errors[selectedFilter?.key]).length === 0);

  //   const selectedValue = filterObj[selectedFilter?.key];

  //   const isSelectedValueValid =
  //     (Array.isArray(selectedValue) && selectedValue.length > 0) ||
  //     (typeof selectedValue === "object" &&
  //       selectedValue !== null &&
  //       Object.values(selectedValue).some((v) => v !== undefined && v !== "")) ||
  //     (typeof selectedValue !== "object" && selectedValue !== undefined && selectedValue !== "");

  //   let cleanedFilters = {};

  //   if (selectedFilterHasNoError && isSelectedValueValid) {
  //     // Only apply selected filter if others have errors
  //     cleanedFilters = {
  //       [selectedFilter.key]: selectedValue,
  //     };
  //   }

  //   // If no errors at all, include all valid filters
  //   const hasAnyError = Object.values(errors).some(
  //     (err) =>
  //       (typeof err === "string" && err.trim() !== "") ||
  //       (typeof err === "object" && Object.keys(err).length > 0)
  //   );

  //   if (!hasAnyError) {
  //     cleanedFilters = Object.entries(filterObj).reduce((acc, [key, value]) => {
  //       const hasNoError =
  //         !errors[key] ||
  //         (typeof errors[key] === "string" && errors[key].trim() === "") ||
  //         (typeof errors[key] === "object" && Object.keys(errors[key]).length === 0);

  //       const hasValidValue =
  //         (Array.isArray(value) && value.length > 0) ||
  //         (typeof value === "object" &&
  //           value !== null &&
  //           Object.values(value).some((v) => v !== undefined && v !== "")) ||
  //         (typeof value !== "object" && value !== undefined && value !== "");

  //       if (hasNoError && hasValidValue) {
  //         acc[key] = value;
  //       }

  //       return acc;
  //     }, {});
  //   }

  //   // Apply cleaned filters if there's at least one valid entry
  //   if (Object.keys(cleanedFilters).length > 0) {
  //     setAppliedFilters(cleanedFilters);
  //     onFilterChange(cleanedFilters);
  //     onClose();
  //   }
  // };
  const applyFilters = () => {
    const cleanedFilters = {};

    for (const key in filterObj) {
      const value = filterObj[key];
      const error = errors[key];

      const isValid =
        (!error ||
          (typeof error === "string" && error.trim() === "") ||
          (typeof error === "object" && Object.keys(error).length === 0)) &&
        ((Array.isArray(value) && value.length > 0) ||
          (typeof value === "object" &&
            value !== null &&
            Object.values(value).some((v) => v !== undefined && v !== "")) ||
          (typeof value !== "object" && value !== undefined && value !== ""));

      if (isValid) {
        cleanedFilters[key] = value;
      }
    }

    if (Object.keys(cleanedFilters).length > 0) {
      setAppliedFilters(cleanedFilters);
      onFilterChange(cleanedFilters);
      onClose();
    } else {
      // Optionally show a message or toast if no valid filters
      console.warn("No valid filters to apply.");
    }
  };

  const handleReset = () => {
    const emptyFilters = {};
    setFilterObj(emptyFilters);
    setAppliedFilters(emptyFilters);
    onFilterChange(emptyFilters); // This will clear the filters in parent
    setErrors({});
    onClose();
  };

  return (
    <Modal open={isOpen} onClose={onClose} aria-labelledby="modal-title">
      <Box className={style.main_div} sx={{ width: "52%" }}>
        <Box className={style.button_div} sx={{ margin: "15px" }}>
          <Box className={style.close_btn}>
            <IconButton onClick={onClose} sx={{ color: "black" }}>
              <CloseIcon sx={{ fontSize: "1.2rem" }} />
            </IconButton>
          </Box>
        </Box>

        <Box className={style.secondary_div}>
          <Box
            sx={{
              width: "36%",
              backgroundColor: "#488257",
              height: "100vh",
            }}
          >
            <Typography variant="h5" sx={{ color: "white", mt: 1, p: 2 }}>
              Filter
            </Typography>
            <Grid item xs={4} style={{}}>
              <div style={{ marginTop: "0.5rem" }}>
                {filters?.map((filter) => {
                  const isSelected =
                    filter.key in appliedFilters &&
                    ((filter.type === "date" &&
                      (appliedFilters[filter.key]?.start ||
                        appliedFilters[filter.key]?.end)) ||
                      (filter.type === "month" &&
                        (appliedFilters[filter.key]?.start ||
                          appliedFilters[filter.key]?.end)) ||
                      (filter.type === "limit" &&
                        (appliedFilters[filter.key]?.min !== undefined ||
                          appliedFilters[filter.key]?.max !== undefined)) ||
                      (Array.isArray(appliedFilters[filter.key]) &&
                        appliedFilters[filter.key]?.length > 0) ||
                      (filter.type === "year" && appliedFilters[filter.key]));

                  return (
                    <ListItem key={filter?.key} disablePadding>
                      <ListItemButton
                        onClick={() => setSelectedFilter(filter)}
                        selected={selectedFilter?.key === filter.key}
                        sx={{
                          backgroundColor:
                            selectedFilter?.key === filter.key
                              ? "#ffffff"
                              : "inherit",
                          "&.Mui-selected": {
                            backgroundColor: "#ffffff",
                            "&:hover": {
                              backgroundColor: "#f5f5f5",
                            },
                          },
                        }}
                      >
                        <ListItemText
                          primary={filter.title}
                          sx={{
                            color:
                              selectedFilter?.key === filter?.key
                                ? "#488257"
                                : "#ffffff",
                          }}
                        />
                        {isSelected && (
                          <FiberManualRecordIcon
                            sx={{
                              fontSize: "10px",
                              color:
                                selectedFilter?.key === filter?.key
                                  ? "#488257"
                                  : "#ffffff",
                            }}
                          />
                        )}
                      </ListItemButton>
                    </ListItem>
                  );
                })}
              </div>
            </Grid>
          </Box>

          <Box
            style={{
              width: "64%",
              maxWidth: "64%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              marginLeft: "1rem",
              marginTop: "0.5rem",
            }}
          >
            <Box>
              <Grid item xs={8} sx={{ p: "0.5rem", height: "100%" }}>
                {selectedFilter && (
                  <div>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        // color: "#488257",
                        fontSize: "24px",
                        fontWeight: "700",
                        marginBottom: "1rem",
                      }}
                    >
                      {selectedFilter.title}
                    </Typography>

                    {selectedFilter?.type === "month" ? (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "1rem",
                          width: "330px",
                          mt: "1.5rem",
                        }}
                      >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          {/* Start Month Picker */}
                          <Box sx={{ width: "47%" }}>
                            <DatePicker
                              views={["year", "month"]}
                              // label="Start Month"
                              value={
                                filterObj[selectedFilter?.key]?.start
                                  ? dayjs(filterObj[selectedFilter?.key]?.start)
                                  : null
                              }
                              onChange={(value) =>
                                handleMonthChange(
                                  selectedFilter?.key,
                                  "start",
                                  value
                                )
                              }
                              maxDate={dayjs()}
                              format="MM/YYYY"
                              label="Start Month"
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  inputProps={{
                                    ...params.inputProps,
                                    value: params.inputProps.value
                                      ? format(
                                          new Date(params.inputProps.value),
                                          "MM yyyy"
                                        )
                                      : "",
                                  }}
                                />
                              )}
                            />
                          </Box>
                          <Typography
                            sx={{ fontWeight: "bold", marginTop: "1rem" }}
                          >
                            to
                          </Typography>

                          {/* End Month Picker */}
                          <Box sx={{ width: "47%" }}>
                            <DatePicker
                              views={["year", "month"]}
                              // label="End Month"
                              value={
                                filterObj[selectedFilter?.key]?.end
                                  ? dayjs(filterObj[selectedFilter?.key]?.end)
                                  : null
                              }
                              onChange={(value) =>
                                handleMonthChange(
                                  selectedFilter?.key,
                                  "end",
                                  value
                                )
                              }
                              minDate={
                                filterObj[selectedFilter?.key]?.start
                                  ? dayjs(filterObj[selectedFilter?.key]?.start)
                                  : null
                              }
                              format="MM/YYYY"
                              label="End Month"
                              maxDate={dayjs()}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  inputProps={{
                                    ...params.inputProps,
                                    value: params.inputProps.value
                                      ? format(
                                          new Date(params.inputProps.value),
                                          "MMM yyyy"
                                        )
                                      : "",
                                  }}
                                />
                              )}
                            />
                          </Box>
                        </LocalizationProvider>
                      </Box>
                    ) : selectedFilter.type === "option" ? (
                      <Box
                        sx={{
                          width: "300px",
                          height: "520px",
                          overflowY: "auto",
                          display: "flex",
                          flexDirection: "column",
                          ml: 1,
                        }}
                      >
                        {selectedFilter?.value?.map((option) => (
                          <FormControlLabel
                            key={option}
                            control={
                              <Checkbox
                                checked={(
                                  filterObj[selectedFilter.key] || []
                                ).includes(option)}
                                onChange={(e) =>
                                  handleOptionChange(
                                    selectedFilter.key,
                                    option,
                                    e.target.checked
                                  )
                                }
                              />
                            }
                            label={option}
                          />
                        ))}
                      </Box>
                    ) : selectedFilter.type === "date" ? (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "1rem",
                          width: "330px",
                          mt: "1.5rem",
                        }}
                      >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            gap="5px"
                          >
                            <Box width="47%">
                              <DatePicker
                                label="Start Date"
                                value={
                                  filterObj[selectedFilter?.key]?.start
                                    ? dayjs.utc(
                                        filterObj[selectedFilter?.key]?.start
                                      )
                                    : null
                                }
                                onChange={(newValue) =>
                                  handleDateChange(
                                    selectedFilter?.key,
                                    "start",
                                    newValue
                                  )
                                }
                                format="DD/MM/YYYY"
                                maxDate={today}
                                renderInput={(params) => (
                                  <TextField
                                    fullWidth
                                    {...params}
                                    inputProps={{
                                      ...params.inputProps,
                                      placeholder: "DD/MM/YYYY",
                                    }}
                                  />
                                )}
                              />
                            </Box>
                            <Typography sx={{ fontWeight: "bold", mx: "5px" }}>
                              to
                            </Typography>
                            <Box width="47%">
                              <DatePicker
                                label="End Date"
                                value={
                                  filterObj[selectedFilter?.key]?.end
                                    ? dayjs.utc(
                                        filterObj[selectedFilter?.key]?.end
                                      )
                                    : null
                                }
                                onChange={(newValue) =>
                                  handleDateChange(
                                    selectedFilter?.key,
                                    "end",
                                    newValue
                                  )
                                }
                                format="DD/MM/YYYY"
                                maxDate={today}
                                minDate={
                                  filterObj[selectedFilter?.key]?.start
                                    ? dayjs.utc(
                                        filterObj[selectedFilter?.key]?.start
                                      )
                                    : null
                                }
                                renderInput={(params) => (
                                  <TextField
                                    fullWidth
                                    {...params}
                                    inputProps={{
                                      ...params.inputProps,
                                      placeholder: "DD/MM/YYYY",
                                    }}
                                  />
                                )}
                              />
                            </Box>
                          </Box>
                        </LocalizationProvider>
                      </Box>
                    ) : selectedFilter.type === "dateTime" ? (
                      <div
                        style={{ display: "flex", gap: "1rem", mt: "1.5rem" }}
                      >
                        <TextField
                          type="date"
                          sx={{ width: "40%" }}
                          size="small"
                          onChange={(e) =>
                            handleDateChange(
                              selectedFilter.key,
                              "start",
                              e.target.value
                            )
                          }
                          value={filterObj[selectedFilter.key]?.start || ""}
                          name="start"
                          variant="outlined"
                        />
                        <TextField
                          type="time"
                          sx={{ width: "40%" }}
                          size="small"
                          onChange={(e) =>
                            handleTimeChange(selectedFilter.key, e.target.value)
                          }
                          value={time || ""}
                          name="start"
                          variant="outlined"
                        />
                      </div>
                    ) : selectedFilter.type === "limit" ? (
                      <div style={{ width: "320px", marginTop: "1.5rem" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                          }}
                        >
                          <div style={{ width: "47%" }}>
                            <TextField
                              type="text"
                              fullWidth
                              onChange={(e) =>
                                handleLimitChange(
                                  selectedFilter.key,
                                  "min",
                                  e.target.value
                                )
                              }
                              placeholder={placeholderMin || "Min"}
                              value={filterObj[selectedFilter.key]?.min || ""}
                              name="min"
                              variant="outlined"
                              size="small"
                              error={!!errors.combined}
                            />
                          </div>

                          <Typography
                            sx={{ fontWeight: "bold", margin: "0 5px" }}
                          >
                            to
                          </Typography>

                          <div style={{ width: "47%" }}>
                            <TextField
                              type="text"
                              fullWidth
                              onChange={(e) =>
                                handleLimitChange(
                                  selectedFilter.key,
                                  "max",
                                  e.target.value
                                )
                              }
                              placeholder={placeholderMax || "Max"}
                              value={filterObj[selectedFilter.key]?.max || ""}
                              name="max"
                              variant="outlined"
                              size="small"
                              error={!!errors.combined}
                            />
                          </div>
                        </div>

                        {/* Combined error message */}
                        {errors[selectedFilter.key] && (
                          <Typography
                            variant="caption"
                            color="error"
                            sx={{ marginTop: "5px" }}
                          >
                            {errors[selectedFilter.key]}
                          </Typography>
                        )}
                      </div>
                    ) : selectedFilter.type === "year" ? (
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          views={["year"]}
                          label="Select Year"
                          value={
                            filterObj[selectedFilter.key]
                              ? dayjs(filterObj[selectedFilter.key], "YYYY")
                              : null
                          }
                          onChange={(value) => {
                            setFilterObj((prev) => ({
                              ...prev,
                              [selectedFilter.key]: value
                                ? value.format("YYYY")
                                : null,
                            }));
                          }}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                          maxDate={dayjs()}
                        />
                      </LocalizationProvider>
                    ) : null}
                  </div>
                )}
              </Grid>
            </Box>

            <Box
              sx={{
                display: "flex",
                width: "100%",
                gap: "3%",
                position: "fixed",
                bottom: "20px",
                marginLeft: "25px",
              }}
            >
              <ApplyButton handleApply={applyFilters} />
              <ResetButton handleReset={handleReset} />
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default FilterModal;
